import React from "react";
import Helmet from "react-helmet";

import Layout from "../components/layout";
// import Lightbox from 'react-images'

import equinox from "../assets/images/thumbs/equinoxthumb.jpg";
import tshqthemes from "../assets/images/thumbs/tshqthemes.jpg";
import tshqmarketing from "../assets/images/thumbs/tshqmarketing.png";
import seamless from "../assets/images/thumbs/seamless.png";
import sportsconnectmarketingvideos from "../assets/images/thumbs/sportsconnectvideos.jpg";
import studentsports from "../assets/images/thumbs/StudentSports.jpg";
import sebrene from "../assets/images/thumbs/sebrene.jpg";
import hooters from "../assets/images/thumbs/hooters.png";
import stacksports from "../assets/images/thumbs/StackSports.jpg";
import famr from "../assets/images/thumbs/FAMR.jpg";
import sportsconnectwebsite from "../assets/images/thumbs/SportsConnect.jpg";
import brandedrockcanyon from "../assets/images/thumbs/brandedrockcanyon.jpg";
import affinitysports from "../assets/images/thumbs/affinity.png";
import sportsconnectmyaccount from "../assets/images/thumbs/sportsconnectmyaccount.png";
import sportsconnectadminlanding from "../assets/images/thumbs/sportsconnectadminlanding.png";


class HomeIndex extends React.Component {
  render() {
    const siteTitle = "Andy Miller - Web & Graphic Design";
    const siteDescription = "Portfolio site of Andy Miller";

    return (
      <Layout>
        <Helmet>
          <title> {siteTitle} </title>
          <meta name="description" content={siteDescription} />
        </Helmet>
        <div id="main">
          <section id="recentwork">
            <h2> Recent Work </h2>
            <div className="row uniform margin-bottom 50%">
            <div className="6u 12u$(small)">
                <a class="image fit thumb" href="/sportsconnectadminlandingpage">
                  <img src={sportsconnectadminlanding}></img>
                </a>
                <h4>Sports Connect Admin Landing Page</h4>
                <p>Wireframes and Prototypes for Sports Connect Admin Landing Page</p>
              </div>

              <div className="6u 12u$(small)">
                <a class="image fit thumb" href="/affinitysportseventui">
                  <img src={affinitysports}></img>
                </a>
                <h4>Affinity Sports Events UI/UX</h4>
                <p>UI Wireframes and Prototypes for Affinity Sports' Events Component</p>
              </div>
            </div>

            <div className="row uniform margin-bottom 50%">
            <div className="6u 12u$(small)">
                <a class="image fit thumb" href="/sportsconnectmyaccount">
                  <img src={sportsconnectmyaccount}></img>
                </a>
                <h4>Sports Connect My Account UI/UX</h4>
                <p>UI Wireframes and Prototypes for Sports Connect My Account System</p>
              </div>

              <div className="6u 12u$(small)">
                <a class="image fit thumb" href="/stacksports">
                  <img src={stacksports}></img>
                </a>
                <h4>Stack Sports</h4>
                <p>Design and Development of Stack Sports Website</p>
              </div>
            </div>

            <div className="row uniform margin-bottom 50%">
              <div className="6u 12u$(small)">
                <a class="image fit thumb" href="/brandedrockcanyon">
                  <img src={brandedrockcanyon}></img>
                </a>
                <h4>Branded Rock Canyon</h4>
                <p>Proof-of-Concept Rebrand and Website</p>
              </div>

              <div className="6u 12u$(small)">
                <a class="image fit thumb" href="/famr">
                  <img src={famr}></img>
                </a>
                <h4>Federal Award Management Registration</h4>
                <p>Design & Development of FAMR Website and Support Videos </p>
              </div>
            </div>

            <div className="row uniform margin-bottom 50%">
            <div className="6u 12u$(small)">
                <a class="image fit thumb" href="/studentsports">
                  <img src={studentsports}></img>
                </a>
                <h4>Student Sports</h4>
                <p>Design & Development of Student Sports Website</p>
              </div>

              <div className="6u 12u$(small)">
                <a class="image fit thumb" href="/sportsconnectwebsite">
                  <img src={sportsconnectwebsite}></img>
                </a>
                <h4>Sports Connect Website </h4>
                <p>Design and Development of Sports Connect Website</p>
              </div>
            </div>

            <div className="row uniform margin-bottom 50%">
            <div className="6u 12u$(small)">
                <a class="image fit thumb" href="/sportsconnectmarketingvideos">
                  <img src={sportsconnectmarketingvideos}></img>
                </a>
                <h4>Sports Connect Marketing Videos</h4>
                <p>Marketing Videos for Sports Connect</p>
              </div>

              <div className="6u 12u$(small)">
                <a class="image fit thumb" href="/sportsconnect">
                  <img src={tshqthemes}></img>
                </a>
                <h4>Sports Connect Website Designs</h4>
                <p>Designs for Website Themes & Portals</p>
              </div>
            </div>

            <div className="row uniform margin-bottom 50%">
            <div className="6u 12u$(small)">
                <a class="image fit thumb" href="/tshqmarketing">
                  <img src={tshqmarketing}></img>
                </a>
                <h4>Dick's Team Sports HQ Marketing</h4>
                <p>Marketing Material for Dick's Sporting Goods</p>
              </div>
              
              <div className="6u 12u$(small)">
                <a class="image fit thumb" href="/seamless">
                  <img src={seamless}></img>
                </a>
                <h4>Seamless App Design</h4>
                <p>UI/UX & Branding for Project Seamless</p>
              </div>
            </div>

            <div className="row uniform margin-bottom 50%">
            <div className="6u 12u$(small)">
                <a class="image fit thumb" href="/hootersmenus">
                  <img src={hooters}></img>
                </a>
                <h4>Hooters Beer Menus</h4>
                <p>Beer Menu Design and Development for Hooters</p>
              </div>


              <div className="6u 12u$(small)">
                <a class="image fit thumb" href="/sebrene">
                  <img src={sebrene}></img>
                </a>
                <h4>Sebrene</h4>
                <p>Website Design and Development</p>
              </div>
            </div>
          </section>

          <section id="photography">
            <div className="row uniform 50%">
              <div className="12u 12u$(small)">
                <a href="http://unsplash.com/sebrene" class="button">
                  Photography
                </a>
              </div>
            </div>
          </section>
          <section id="contact">
            <center><p>Copyright © 2022 Andrew Miller. Created with React & Gatsby.js</p></center>
          </section>
        </div>
      </Layout>
    );
  }
}

export default HomeIndex;
